<div class="container">
    <div class="header">
        <h6 class="title">
            {{ 'system-settings.slot.title' | translate: { type: slotType } }}
        </h6>
        <div class="sub-title">
            {{ this.data.title }}
        </div>
    </div>
    <div class="main">
        <div class="description">
            <ng-container *ngIf="isDOType">
                {{ 'system-settings.do-slot.description' | translate }}
            </ng-container>
            <ng-container *ngIf="isDIType">
                {{ 'system-settings.di-slot.description' | translate }}
            </ng-container>
            <ng-container *ngIf="isAIType">
                {{ 'system-settings.ai-slot.description' | translate }}
            </ng-container>
            <ng-container *ngIf="isAOType">
                {{ 'system-settings.ao-slot.description' | translate }}
            </ng-container>
        </div>
        <ng-container *ngIf="isDOType">
            <div class="terminal-input">
                <div class="terminal-data">
                    <div *ngFor="let terminal of selectedTerminals; let i = index" class="terminal-item">
                        <div class="terminal-text">
                            <span>{{ getTerminalTitle(terminal) | translate }}</span>
                            <span class="side-text">
                                {{ getTerminalType(terminal).key | translate: getTerminalType(terminal).params }}
                            </span>
                        </div>
                        <div class="icon-wrapper">
                            <mat-icon
                                class="close-icon"
                                svgIcon="close"
                                (click)="deleteTerminal(terminal.index)"></mat-icon>
                        </div>
                    </div>
                    <div class="placeholder" *ngIf="selectedTerminals.length === 0">
                        {{ 'system-settings.do-slot.placeholder' | translate }}
                    </div>
                </div>
                <div class="remaining-slots">
                    <span>{{ 'system-settings.slot.seats.description' | translate: { num: remainingTerminals } }}</span>
                </div>
            </div>
            <div class="terminal-button-wrapper">
                <app-terminal-button
                    *ngFor="let option of terminalOptions"
                    [terminalType]="option.type"
                    [titleKey]="option.titleKey"
                    [terminalCount]="option.terminalCount"
                    [disabled]="isTerminalDisabled(option.type)"
                    [option]="option"
                    [onClick]="onTerminalClick">
                </app-terminal-button>
            </div>
        </ng-container>
        <ng-container *ngIf="isDIType">
            <div class="terminal-button-wrapper">
                <div class="terminal-button-container">
                    <div>
                        {{ 'system-settings.di-slot.first.title' | translate }}
                    </div>
                    <div class="terminal-options-container">
                        <div
                            class="terminal-button"
                            [class.selected]="isTerminalSelected(LEFT_TERMINAL)"
                            (click)="addNormalTerminal(LEFT_TERMINAL)">
                            {{ 'system-settings.di-slot.left' | translate }}
                        </div>
                        <div
                            class="terminal-button"
                            [class.selected]="isTerminalSelected(RIGHT_TERMINAL)"
                            (click)="addNormalTerminal(RIGHT_TERMINAL)">
                            {{ 'system-settings.di-slot.right' | translate }}
                        </div>
                    </div>
                </div>
                <div class="terminal-button-container">
                    <div>
                        {{ 'system-settings.di-slot.second.title' | translate }}
                    </div>
                    <div class="terminal-options-container">
                        <div
                            class="terminal-button"
                            [class.selected]="isTerminalSelected(LEFT_TERMINAL, true)"
                            (click)="addNormalTerminal(LEFT_TERMINAL, true)">
                            {{ 'system-settings.di-slot.left' | translate }}
                        </div>
                        <div
                            class="terminal-button"
                            [class.selected]="isTerminalSelected(RIGHT_TERMINAL, true)"
                            (click)="addNormalTerminal(RIGHT_TERMINAL, true)">
                            {{ 'system-settings.di-slot.right' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isAOType || isAIType">
            <div class="terminal-button-container">
                <div>
                    {{ 'system-settings.ao-slot.title' | translate }}
                </div>
                <div class="terminal-options-container">
                    <div
                        class="terminal-button"
                        data-cy="ops-settings-system-setting-slot-setting-left-button"
                        [class.selected]="isTerminalSelected(LEFT_TERMINAL)"
                        (click)="addNormalTerminal(LEFT_TERMINAL)">
                        {{ 'system-settings.ao-slot.left' | translate }}
                    </div>
                    <div
                        class="terminal-button"
                        data-cy="ops-settings-system-setting-slot-setting-right-button"
                        [class.selected]="isTerminalSelected(RIGHT_TERMINAL)"
                        (click)="addNormalTerminal(RIGHT_TERMINAL)">
                        {{ 'system-settings.ao-slot.right' | translate }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="button-container">
        <button class="text-button" (click)="close()">
            {{ 'dlg.cancel' | translate }}
        </button>
        <app-button
            [disable]="isSaveDisabled"
            [text]="saveButtonText"
            customFontFamily="NotoSans-Medium"
            size="tall"
            customFontSize="14px"
            (onClick)="save()"></app-button>
    </div>
</div>
